import React, {useCallback, useEffect, useMemo, useState} from 'react';
import BackButton from '../../cmp/BackButton';
import {searchForProducts} from '../inportalstore/redux/cart_actions';
import {useSelector, useDispatch} from 'react-redux'
import useDebounce from '../../cmp/hooks/useDebounce';
import FormGroup from '../../cmp/form/FormGroup';
import Skeleton from 'react-loading-skeleton'
import {
  actionMergeSetting,
} from '../../../redux/settings/settingsAction';
import {post} from '../../../api';
import {CheckIcon, XIcon} from '../../../icons/Icons';
import Button from '../../auth/components/Button';

function PublicShopOptions(props) {
    const [search, setSearch] = useState('')
    const [products, setProducts] = useState(null)
    const affiliate_shop_storefront_token = useSelector((state)=>state.settings.affiliate_shop_storefront_token)
    const metadata = useSelector((state)=>state.settings.metadata ? JSON.parse(state.settings.metadata) || {} : null)
    const {publicShopSelection, publicShopSelectionIds} = useMemo(()=>{
        return metadata || {}
    },[metadata])
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const _search = useDebounce(search, 300)
    const [nextCursor, setNextCursor] = useState(null)
    const [hasNext, setHasNext] = useState(false)
    const [loadNext, setLoadNext] = useState(0)
    useEffect(()=>{
      setProducts([])
      setLoadNext((l)=>l+1)
      setNextCursor(null)
    },[_search])

    useEffect(()=>{
        setLoading(true)
        dispatch(searchForProducts(_search, nextCursor, affiliate_shop_storefront_token))
            .then(({products, cursor, hasNext})=>{
                setProducts((p)=>[...p,...products])
                if(hasNext){
                  setHasNext(true)
                }
                if(cursor){
                  setNextCursor(cursor)
                }
               setLoading(false)
        })
    },[dispatch, loadNext, affiliate_shop_storefront_token])

  const setSelectionType = function(e){

      const meta = {...(metadata || {}), publicShopSelectionIds: e.target.value !== "only_selected" ? null : undefined, publicShopSelection: e.target.value || null}
      dispatch(actionMergeSetting({metadata: JSON.stringify(meta)}))
      post('/', {
        metadata: meta
      }).then((data) => {
//        dispatch(actionMergeSetting({metadata: JSON.stringify(meta)}))
      })
  }

  const toggleSelection = useCallback((id)=>{
      const existing = publicShopSelectionIds || [];
      const newSelection = existing.indexOf(id) > -1 ? existing.filter((d)=>d!==id) : [id, ...existing]
      const meta = {...(metadata || {}), publicShopSelectionIds: newSelection}
      dispatch(actionMergeSetting({metadata: JSON.stringify(meta)}))
      post('/', {
        metadata: meta
      }).then((data) => {
    //    dispatch(actionMergeSetting({metadata: JSON.stringify(meta)}))
      })
  },[dispatch, metadata, publicShopSelectionIds])

    return (
        <>
            <BackButton />
            <h2>Edit Shop</h2>
            <FormGroup>
              <select className={"form-control"} value={publicShopSelection} onChange={setSelectionType}>
                <option value="">Show all products</option>
                <option value="only_selected">Show selected products</option>
              </select>
            </FormGroup>
          {
            publicShopSelection === "only_selected" ? <>
              <FormGroup>
                <input placeholder={"Find products"} type="search"
                       className={"form-control"} value={search}
                       onChange={(e) => setSearch(e.target.value)}/>
              </FormGroup>
              <div className="row">
                 {
                      products ? products.map((item) => {
                            return <div
                                className={"d-flex col-md-4 mb-2 col-lg-3 col-sm-6"}>
                              <div className="card" style={{flex: '1 1 0%'}}>
                                <img loading={"lazy"} src={item.images  && item.images.length > 0 ?
                                    item.images[0].src :
                                    null
                                }
                                     style={{width: '100%'}}
                                     alt={item.title}/>
                                <div className="card-body">
                                  {item.title}
                                </div>
                                <div className="card-footer d-flex align-items-center justify-content-between">
                                  {publicShopSelectionIds &&
                                  publicShopSelectionIds.indexOf(
                                      item.platform_product_id) > -1 ?
                                      <>
                                        <button onClick={(e) => toggleSelection(item.platform_product_id)} className="btn btn-sm btn-link px-0 text-danger">Remove</button>
                                        <CheckIcon className={"text-success"} />
                                      </> :<>
                                      <button onClick={(e) => toggleSelection(item.platform_product_id)} className="btn btn-sm btn-link px-0">Add</button>
                                      <XIcon className={"text-danger"} />
                                      </>
                                  }
                                </div>
                              </div>
                            </div>
                          }) : null
                  }
                {
                    loading && <>
                    {
                      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => {
                        return <div
                            key={String(item)}
                            className={"col-md-4 mb-2 col-lg-3 col-sm-6"}>
                          <Skeleton height={300}/>
                        </div>
                      })
                    }
                  </>
                }
              </div>
              {
                hasNext && products.length > 0 && <div className="text-center">
                  <Button
                        onClick={()=>setLoadNext((x)=>x+1)}
                        loading={loading}
                                                         className={'btn btn-light'}>Load more</Button>
                </div>
              }
            </> : null
          }
        </>
    );
}

export default PublicShopOptions;
